
import SharedFooter from '../../../components/feature/SharedFooter';

export default function Footer() {
  return <SharedFooter />;
}
